import type { EditorState } from '@/stateManagement';
import type { GridLinesType } from '@/constants';
import type { GridLine } from 'types/core';

const getGridLinesOverrides = (
  state: EditorState,
  { gridLinesType }: { gridLinesType: GridLinesType },
): GridLine[] => state.gridLines.overrides[gridLinesType];

export { getGridLinesOverrides };
